import { Grid, Box, Typography } from "@mui/material";
import { People, TrendingUp, Task, CurrencyPound } from "@mui/icons-material";
import StatCard from "./StatCard";

const MainStatsCards = ({
  nonAdminUserCount,
  newUsersThisWeek,
  newUsersToday,
  newUsersThisMonth,
  nonAdminTotalVisits,
  visitsToday,
  visitsThisWeek,
  visitsThisMonth,
  nonAdminTasksCreated,
  tasksCreatedThisWeek,
  tasksCreatedToday,
  tasksCreatedThisMonth,
  subscribedUsers,
  monthlyRevenue,
}) => {
  return (
    <Grid
      container
      spacing={3}
      sx={{
        mb: 6,
        "& > .MuiGrid-item": {
          mb: { xs: 2, sm: 3, md: 0 },
        },
      }}
    >
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Total Users"
          value={nonAdminUserCount}
          icon={People}
          color="primary"
          breakdown={{
            today: newUsersToday,
            week: newUsersThisWeek,
            month: newUsersThisMonth,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Total Visits"
          value={nonAdminTotalVisits}
          icon={TrendingUp}
          color="success"
          breakdown={{
            today: Math.round(visitsToday),
            week: Math.round(visitsThisWeek),
            month: Math.round(visitsThisMonth),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Tasks Created"
          value={nonAdminTasksCreated}
          icon={Task}
          color="warning"
          breakdown={{
            today: tasksCreatedToday,
            week: tasksCreatedThisWeek,
            month: tasksCreatedThisMonth,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Subscribed Users"
          value={subscribedUsers}
          icon={CurrencyPound}
          color="success"
          customBreakdown={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Monthly Revenue
              </Typography>
              <Typography variant="h6" fontWeight="bold" color="success.main">
                £{monthlyRevenue}
              </Typography>
            </Box>
          }
        />
      </Grid>
    </Grid>
  );
};

export default MainStatsCards;
